import { useEffect, useState } from "react";

export default function useDelay(loading, delay=1000) {
    const [showLoading, setShowLoading] = useState(loading);

    useEffect(()=>{
        let timer;

        if(loading){
            setShowLoading(true);
        } else {
            timer = setTimeout(() => {
                setShowLoading(false);
            }, delay);
        }

        return () => clearTimeout(timer);
    }, [loading, delay]);

    return showLoading;
}

export const timer = (ms) => new Promise(
    // la cree para esperar unos segundos antes de tirar un error, ej: cuando carga la app y no hay auth tdv
    resolve => setTimeout(resolve, ms)
); 